"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _timePicker = _interopRequireDefault(require("@clayui/time-picker"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var DEFAULT_VALUE = '--';
var ClayDatePickerTimePicker = function ClayDatePickerTimePicker(_ref) {
  var currentTime = _ref.currentTime,
    disabled = _ref.disabled,
    onTimeChange = _ref.onTimeChange,
    spritemap = _ref.spritemap,
    timezone = _ref.timezone,
    use12Hours = _ref.use12Hours;
  var _React$useState = _react.default.useState({
      ampm: DEFAULT_VALUE,
      hours: DEFAULT_VALUE,
      minutes: DEFAULT_VALUE
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    values = _React$useState2[0],
    setValues = _React$useState2[1];

  /**
   * Handles the control time picker
   */
  var handleOnChange = function handleOnChange(values) {
    var hours = values.hours === DEFAULT_VALUE ? DEFAULT_VALUE : Number(values.hours);
    var minutes = values.minutes === DEFAULT_VALUE ? DEFAULT_VALUE : Number(values.minutes);
    var ampm = values.ampm ? values.ampm : DEFAULT_VALUE;
    setValues(values);
    onTimeChange(hours, minutes, ampm);
  };
  _react.default.useEffect(function () {
    var _currentTime$split = currentTime.split(':'),
      _currentTime$split2 = _slicedToArray(_currentTime$split, 2),
      hours = _currentTime$split2[0],
      minutesAndAmpm = _currentTime$split2[1];
    var _split = minutesAndAmpm.split(' '),
      _split2 = _slicedToArray(_split, 2),
      minutes = _split2[0],
      ampm = _split2[1];
    setValues(function (prevValues) {
      return _objectSpread(_objectSpread({}, prevValues), {}, {
        ampm: ampm,
        hours: String(hours),
        minutes: String(minutes)
      });
    });
  }, [currentTime, use12Hours]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "time-picker"
  }, /*#__PURE__*/_react.default.createElement(_timePicker.default, {
    disabled: disabled,
    icon: true,
    onInputChange: handleOnChange,
    spritemap: spritemap,
    timezone: timezone,
    use12Hours: use12Hours,
    values: values
  }));
};
var _default = exports.default = ClayDatePickerTimePicker;